/* eslint-disable no-console -- the one sanctioned bridge to the console */
import { LOG_LEVEL_CONSOLE_METHOD } from './logging.maps';
import type { LogDestination, LogEntry } from './logging.types';

/** Formats one entry into console arguments; platform code may supply a richer one. */
export interface ConsoleEntryFormatter {
    format(entry: LogEntry): readonly unknown[];
}

/** Plain `[name] message` + meta formatter. React Native-safe default. */
export class PlainConsoleFormatter implements ConsoleEntryFormatter {
    format(entry: LogEntry): readonly unknown[] {
        const prefix = entry.name === '' ? entry.message : `[${entry.name}] ${entry.message}`;

        return Object.keys(entry.meta).length > 0 ? [prefix, entry.meta] : [prefix];
    }
}

/** Console output; always available and the destination the filter overlay governs. */
export class ConsoleDestination implements LogDestination {
    readonly name = 'console';
    readonly respectsOverlay = true;

    constructor(private readonly formatter: ConsoleEntryFormatter = new PlainConsoleFormatter()) {}

    write(entry: LogEntry): void {
        console[LOG_LEVEL_CONSOLE_METHOD[entry.level]](...this.formatter.format(entry));
    }
}
